import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-overview-aboutproject-section',
  templateUrl: './overview-aboutproject-section.component.html',
  styleUrls: ['./overview-aboutproject-section.component.scss'],
})
export class OverviewAboutprojectSectionComponent implements OnInit {
  @Input() aboutProjectInfo: any;
  @ViewChild('sliderImg') sliderImg: ElementRef<SwiperContainer>;

  text: string;
  imageUrl: string;
  isMoreOpen = false;

  // pasado como [passedParams] al swiper-container: así se reaplica solo cada vez que Ionic
  // reconecta la página al stack de navegación (el swiper-element se destruye en cada disconnect).
  slideOpts = {
    initialSlide: 0,
    speed: 1000,
    effect: 'slide',
    spaceBetween: 20,
    slidesPerView: 1,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  };
  sliderIndex = 0;

  constructor() { }

  ngOnInit() {
    if (this.aboutProjectInfo.imageUrl !== null && this.aboutProjectInfo.imageUrl !== undefined) {
      this.imageUrl = this.aboutProjectInfo.imageUrl;
    }
    this.text = this.aboutProjectInfo.text.replace(/\↵/ig, '<br>');
  }

  next() {
    this.sliderImg.nativeElement.swiper.slideNext();
  }

  prev() {
    this.sliderImg.nativeElement.swiper.slidePrev();
  }

  getCurrentItem() {
    this.sliderIndex = this.sliderImg.nativeElement.swiper.activeIndex;
  }

}
